import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const PublicRoute = ({ children }) => {
  const userId = localStorage.getItem('id');
  const location = useLocation();

  // Allow /accept-employee-invite route even when logged in
  // The Reset component will handle logging out the user
  const isResetPage = location.pathname === '/accept-employee-invite';

  // If user is already logged in, redirect to dashboard
  // Exception: allow reset page to be accessed (it will log out the user)
  if (userId && !isResetPage) {
    return <Navigate to="/dashboard" replace />;
  }
  
  return children;
};

export default PublicRoute;

